import { useState } from 'react';
import { motion } from 'framer-motion';

import { pageAnimation } from '@const/animation';
import { Icon, TIconType } from '@components/icons';
import Info from '@components/common/info';

import DevPageHeader from '../_shared/PageHeader';
import StoreCheckout from './StoreCheckout';
import LotteryConnect from './LotteryConnect';
import ApiConsole from './ApiConsole';
import styles from './styles.module.scss';

type SandboxTab = 'store' | 'connect' | 'api';

const TABS: { id: SandboxTab; label: string; icon: TIconType }[] = [
    { id: 'store', label: 'Pay with XEPPT', icon: 'money' },
    { id: 'connect', label: 'Connect', icon: 'identity' },
    { id: 'api', label: 'API console', icon: 'send' }
];

const DevelopersSandboxLayout = () => {
    const [tab, setTab] = useState<SandboxTab>('store');

    return (
        <motion.div {...pageAnimation} className={styles.wrapper}>
            <DevPageHeader
                title="Sandbox"
                subtitle="Test your integration with simulated data — pick a tool below. No live funds ever move."
                actions={
                    // The topbar already has its own env pill (driven by the API key's
                    // test/live mode) — this one is a separate, always-sandbox concept.
                    // A hover tooltip keeps the two from reading as the same control.
                    <Info
                        variant="bottom"
                        content="This tool always runs in test mode, independent of your API key environment.">
                        <div className={[styles.env_pill, styles.env_test].join(' ')}>
                            <span className={styles.env_dot} />
                            <span className={styles.env_label}>Sandbox</span>
                        </div>
                    </Info>
                }
            />

            <div className={styles.tabs}>
                {TABS.map((t) => (
                    <button
                        key={t.id}
                        className={[styles.tab, tab === t.id ? styles.tab_active : ''].join(' ')}
                        onClick={() => setTab(t.id)}
                        type="button">
                        <Icon name={t.icon} width={17} height={17} />
                        {t.label}
                    </button>
                ))}
            </div>

            <div className={styles.tab_body}>
                {tab === 'store' && <StoreCheckout />}
                {tab === 'connect' && <LotteryConnect />}
                {tab === 'api' && <ApiConsole />}
            </div>
        </motion.div>
    );
};

export default DevelopersSandboxLayout;
